export default "__VITE_ASSET__Cis5325H__"